import React, {useEffect, useRef, useState} from 'react';
import {FormControl, makeStyles, TextField, Tooltip} from "@material-ui/core";
import FieldWrapper from "../FieldWrapper";
import {setArrayPath} from "../Utils/setArrayPath";
import findByString from "../Utils/getValueByString";
import {errorHandler} from "../Utils/errorHandler";
import FieldErrorMessage from "../Utils/errorMessage";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../Components/JsonScreen/Utils/lib";
import MultiLngMenu from "../Utils/MultiLngMenu";
import {useValidateField} from "../Utils/validator";
import {checkHidden} from "../Utils/checkHidden";
import SortableContainer from "../../../ReactSelectMaterial/Sortable/SortableContainer";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SortableItem from "../../../ReactSelectMaterial/Sortable/SortableItem";
import Chip from "@material-ui/core/Chip";
import update from "immutability-helper";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
    formControl: {
        minWidth: 'auto',
        width: '100%'
    },
    textarea: {
        resize: "vertical"
    }
}))

const TextType = (props) => {
    const {
        values, fieldStyles, labelStyles, showLabel, errors, setValue,
        goBack, focusNow, history, isMobile, onBlurFromCell,
        containerArrayPath, onChange: onChangeHandler, trackChange,
        field: {
            disabled, pattern, patternTitle, label, required,
            autofocus, dropdown, placeholder, multiLanguage, path,
            hideCondition, isArray, minLength, maxLength
        },
        globalValues, actionsContext, screenName
    } = props;
    const fieldPresentation = fieldStyles.presentation ?
        fieldStyles.presentation === 'inlineWithLabel' ? 'standard' :
            fieldStyles.presentation === 'stackLabel' ? 'outlined' :
                fieldStyles.presentation : 'outlined'
    const isHidden = checkHidden({...globalValues, ...actionsContext}, hideCondition, screenName);
    const isDisabled = checkHidden({...globalValues, ...actionsContext}, disabled, screenName);
    const classes = useStyles();
    const fieldRef = useRef();
    const {validate, errorMessage, isValid} = useValidateField();
    const [fieldValue, setFieldValue] = useState('');
    const [filterValue, setFilterValue] = useState('');
    const [changed, setChanged] = useState(false);
    const [fieldPath, setFieldPath] = useState('');
    const [error, setError] = useState('');

    //mount
    useEffect(() => {
        let value = findByString(values, path);
        validate(value, pattern, patternTitle);
        if (focusNow && isDisabled) {
            onBlurFromCell();
        }
        if (focusNow) {
            fieldRef.current && fieldRef.current.focus()
        }
        setValues();
    }, [])

    //on update values
    useEffect(() => {
        setValues();
    }, [JSON.stringify(values)])

    //on update errors
    useEffect(() => {
        if (errors && errors.length) {
            setErrors();
        }
    }, [JSON.stringify(errors)])

    const setValues = () => {
        try {
            let arrayPath = setArrayPath(path, containerArrayPath);
            let value = findByString(values, arrayPath ? arrayPath : path) || "";
            let currentValue = isArray ? value ? value : [] : value !== undefined ? value : '';

            if (isArray) {
                let isArrayValue = Array.isArray(value);
                if (value && isArrayValue) {
                    currentValue = value;
                }
                if (value && !isArrayValue) {
                    currentValue = [value]
                }

                if (!value) {
                    currentValue = [];
                }
            } else {
                currentValue = value !== undefined ? value : '';
            }

            let initialValue;
            if (isArray) {
                let isArrayValue = Array.isArray(currentValue);
                initialValue = isArrayValue ? currentValue.map((v, i) => ({
                        value: typeof v === 'object' ? v.value : v,
                        idx: `${v}_${i}`
                    }))
                    : currentValue
            } else {
                initialValue = currentValue;
            }


            setFieldPath(arrayPath || path);
            setFieldValue(initialValue)
        } catch (e) {
            console.log(e)
        }
    };
    const setErrors = () => {
        let errorField = errorHandler(errors, path, containerArrayPath);
        validate(null, null, null, errorField)
        setError(errorField)
    };

    const onChange = (event) => {
        try {
            const {value} = event.target;
            setFieldValue(value);
            setFilterValue(value);
            setChanged(true);
            console.log('set changed')
            if (onChangeHandler) {
                onChangeHandler(value, fieldPath)
            }
        } catch (e) {
            console.log('onchange error', e)
        }
    };
    const onBlur = () => {
        if (changed) {
            let currentValue = isArray ?
                (filterValue.length ? [...fieldValue, {value: filterValue}] : fieldValue).map(v => {
                    return v.value
                }) : fieldValue;
            setValue(currentValue, fieldPath, trackChange)
            !isArray && validate(currentValue, pattern, patternTitle);
            isArray && filterValue && setFilterValue('')


        }
        if (focusNow) {
            onBlurFromCell();
        }
        setChanged(false)
    };
    const onChangeFromDropDown = (value) => {
        setFieldValue(value);
        setFilterValue('');
        setChanged(true);
    };
    const applyMultiLngMenu = (values) => {
        let currentValue = !isArray ? values : [];
        setValue(currentValue, fieldPath, trackChange)

        onChange({
            target: {
                value: currentValue
            }
        })

    }

    function onChangeTextField(event) {
        const {value} = event.target;
        setFilterValue(value)
        !changed && setChanged(true);
    }

    function onChangeArrayField(event, values) {
        const newValue = values.map((v, i) => {
            return typeof v === 'object' ? v : {value: v, idx: `${v}_${i}`}
        });
        setFilterValue('');
        setFieldValue(newValue)
        !changed && setChanged(true);
        setValue(newValue.map(v => {
            return v.value
        }), path, trackChange)
    }


    //re-order handlers
    function swapItems(dragIndex, hoverIndex) {
        let newArr = update(fieldValue, {
            $splice: [[dragIndex, 1], [hoverIndex, 0, fieldValue[dragIndex]]],
        });
        setFieldValue(newArr)
    }

    function endDrag() {
        let currentValue = isArray ? fieldValue.map(v => {
            return v.value
        }) : fieldValue;
        setValue(currentValue, path, trackChange)
    }

    return (
        <FieldWrapper
            required={required}
            dropdown={dropdown}
            focusNow={focusNow}
            record={values}
            filterValue={filterValue}
            path={path}
            disabled={isDisabled}
            changed={changed}
            setValue={onChangeFromDropDown}
            fieldRef={fieldRef}
            fieldStyles={fieldStyles}
            labelStyles={{...labelStyles, alignSelf: 'flex-start'}}
            showLabel={showLabel}
            label={label}
            goBack={goBack}
            history={history}
            isMobile={isMobile}
            isHidden={isHidden}
            globalValues={globalValues}
            screenName={screenName}
        >
            <FormControl classes={{root: classes.formControl}} fullWidth={fieldStyles.fullWidth}>
                {!isArray ? (
                    <TextInput
                        onBlur={onBlur}
                        onChange={onChange}
                        pattern={pattern}
                        patternTitle={patternTitle}
                        autofocus={autofocus}
                        fieldValue={fieldValue}
                        required={isHidden ? false : required}
                        fieldRef={fieldRef}
                        disabled={isDisabled}
                        fieldStyles={fieldStyles}
                        placeholder={placeholder}
                        label={label}
                        isMobile={isMobile}
                        multiLanguage={multiLanguage}
                        applyMultiLngMenu={applyMultiLngMenu}
                        isValid={isValid}
                        screenName={screenName}
                    />
                ) : (
                    <TextInputArray
                        onBlur={onBlur}
                        onChange={onChangeArrayField}
                        onChangeTextField={onChangeTextField}
                        applyMultiLngMenu={applyMultiLngMenu}
                        swapItems={swapItems}
                        endDrag={endDrag}
                        pattern={pattern}
                        patternTitle={patternTitle}
                        autofocus={autofocus}
                        fieldValue={fieldValue}
                        required={required}
                        fieldRef={fieldRef}
                        disabled={isDisabled}
                        fieldStyles={fieldStyles}
                        placeholder={placeholder}
                        label={label}
                        isMobile={isMobile}
                        multiLanguage={multiLanguage}
                        isValid={isValid}
                        minLength={minLength}
                        maxLength={maxLength}
                        filterValue={filterValue}
                        error={error}
                        errors={errors}
                        fieldPresentation={fieldPresentation}
                    />
                )}

                <FieldErrorMessage message={errorMessage || error}/>
            </FormControl>
        </FieldWrapper>
    )

}

TextType.propTypes = {
    errors: PropTypes.array,
    //the object of field
    field: PropTypes.object.isRequired,
    fieldStyles: PropTypes.object.isRequired,
    labelStyles: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    //for table fields
    focusNow: PropTypes.bool,
    onBlurFromCell: PropTypes.func,
};

TextType.defaultProps = {
    errors: [],
    goBack: () => {
    },
    setValue: () => {
    },
    values: {},
    labelStyles: {},
    fieldStyles: {}
};

export default TextType

const TextInput = (props) => {
    const {
        fieldStyles, disabled, placeholder, autofocus,
        fieldValue, pattern, patternTitle, onChange, onBlur,
        fieldRef, required, label, isMobile, error,
        multiLanguage, applyMultiLngMenu, isValid, screenName
    } = props;
    const userLanguage = useSelector(state => state.app.userLanguage);
    const classes = useStyles();
    const fieldPresentation = fieldStyles.presentation ?
        fieldStyles.presentation === 'inlineWithLabel' ? 'standard' :
            fieldStyles.presentation === 'stackLabel' ? 'outlined' :
                fieldStyles.presentation : 'outlined'
    const currentTextValue = typeof fieldValue === 'object' ? fieldValue[userLanguage] : fieldValue;

    function handleOnChange(e) {
        if (multiLanguage) {
            onChange({target: {value: {[userLanguage]: e.target.value}}});
        } else {
            onChange(e)
        }
    }

    return (
        <TextField
            multiline={true}
            placeholder={multiLanguageValue(placeholder, userLanguage)}

            disabled={disabled}
            autoFocus={autofocus}
            required={required}
            fullWidth={fieldStyles.fullWidth}
            value={currentTextValue}
            onChange={handleOnChange}
            onBlur={onBlur}
            ref={fieldRef}
            label={(isMobile || fieldStyles.presentation === 'standard') && multiLanguageValue(label, userLanguage)}
            variant={isMobile ? 'standard' : fieldPresentation}
            autoComplete="off"
            error={!isValid}
            style={{
                paddingTop: !isMobile && 3,
                paddingLeft: !isMobile && 2,
                marginBottom: !isMobile && 2
            }}
            className={clsx('sb-field-textarea', screenName, fieldStyles.withoutStyles ?
                'form-dynamic-withoutStyles-textarea' :
                'form-dynamic-textarea')

            }
            inputProps={{
                style: {
                    width: !isMobile && fieldStyles.fullWidth ? '100%' : parseInt(fieldStyles.width),
                    minHeight: fieldStyles.height ? parseInt(fieldStyles.height) : 50
                },
                pattern: pattern,
                title: multiLanguageValue(patternTitle, userLanguage),
                className: classes.textarea,
            }}
            InputProps={{
                endAdornment: multiLanguage &&
                    <MultiLngMenu value={fieldValue} apply={applyMultiLngMenu}
                                  type={'textArea'}
                                  disabled={disabled}
                    />
            }}
        />
    )
};


const useStylesTextFieldArray = makeStyles(({
    inputRoot: {
        '&[class*="MuiInput-root"]': {
            paddingRight: 0,
            '& $input': {
                padding: '2px 4px !important',
            },
        },
        '&[class*="MuiOutlinedInput-root"]': {
            paddingRight: '0 !important',
            padding: '1px !important'
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(0,0,0,0.22)', // Semi-transparent underline
        },
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 1,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    textFieldRoot: {
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(0,0,0,0.22)', // Semi-transparent underline
        },
    },
    paper: {
        width: 'auto',
        '& > ul': {
            maxHeight: 200,
            overflow: 'auto',
        },
    },
    clearIndicator: {
        display: 'none',
    },
    tag: {
        height: '24px'
    },
    chipLabel: {
        textOverflow: 'ellipsis',
        whiteSpace: "normal"
    },
    chipRoot: {
        height: 'auto'
    },
    textarea: {
        resize: "vertical",
        minHeight: 15,
        padding: 10,
    }
}))


const TextInputArray = (props) => {
    const classes = useStylesTextFieldArray();
    const {
        fieldValue, onChange, required, disabled, fieldRef, freeSolo,
        filterValue, onBlur, isMobile, label, fieldStyles, error, autofocus, pattern,
        type, onChangeTextField, path, field, minLength, maxLength, errors, endDrag, swapItems,
        fieldPresentation, placeholder
    } = props;
    const userLanguage = useSelector(state => state.app.userLanguage);
    const inputClassName = fieldStyles.withoutStyles ? 'horizontal-fields-table' : 'form-dynamic-default';
    const customStyles = (isMobile || fieldStyles.presentation === 'standard') ? {
            width: '100%',
            marginTop: 4
        } :
        {
            width: isMobile ? null : parseInt(fieldStyles.width) + 8 || "",
            margin: fieldStyles.margin,
            paddingTop: fieldStyles.withoutPadding ? 0 : !isMobile && 3,
            paddingLeft: fieldStyles.withoutPadding ? 0 : !isMobile && 2,
        };

    return (
        <SortableContainer>
            <Autocomplete
                value={fieldValue || []}
                onChange={onChange}
                disabled={disabled}
                ref={fieldRef}
                multiple
                open={false}
                options={[]}
                freeSolo={!freeSolo}
                classes={{
                    inputRoot: classes.inputRoot,
                    clearIndicator: classes.clearIndicator,
                    option: classes.option,
                    paper: classes.paper,
                    tag: classes.tag,
                }}
                inputValue={filterValue}
                onBlur={onBlur}
                renderInput={params =>
                    <TextField
                        {...params}
                        multiline={true}
                        size={"small"}
                        placeholder={multiLanguageValue(placeholder, userLanguage)}
                        required={required && (fieldValue === null || !fieldValue.length)}
                        autoComplete="off"
                        label={(isMobile || fieldStyles.presentation === 'standard') && multiLanguageValue(label, userLanguage)}
                        fullWidth={isMobile ? true : fieldStyles.fullWidth}
                        className={'form-dynamic-textarea'}
                        classes={{root: classes.textFieldRoot}}
                        error={error.length > 0}
                        inputProps={{
                            ...params.inputProps,
                            style: {
                                width: !isMobile && fieldStyles.width,
                            },
                            pattern: pattern,
                            className: classes.textarea,
                        }}
                        autoFocus={autofocus}
                        variant={isMobile ? 'standard' : fieldPresentation}
                        type={type}
                        onChange={onChangeTextField}
                        style={customStyles}
                    />}
                renderTags={(value, getTagProps) =>
                    value.map((tag, index) => {
                        let error = errorHandler(errors, `${path}.${index}`);
                        return (
                            <SortableItem
                                index={index}
                                key={tag.idx}
                                moveCard={swapItems}
                                endDrag={endDrag}
                                element={field}
                            >
                                <Tooltip title={error.length > 0 ? error : ''}>
                                    <Chip
                                        id={`chip_${index}`}
                                        style={{
                                            border: error.length > 0 ? '1px solid red' : 'none',
                                            textOverflow: 'clip',
                                            maxWidth: fieldStyles.width,
                                        }}
                                        variant="default"
                                        label={tag.value}
                                        tabIndex={-1}
                                        classes={{
                                            label: classes.chipLabel,
                                            root: classes.chipRoot
                                        }}
                                        {...getTagProps({index})}
                                    />
                                </Tooltip>
                            </SortableItem>
                        )
                    })
                }
            />
        </SortableContainer>
    )


}